import axios from "axios";
import { Admin } from "../types/auth";

const API_URL = process.env.REACT_APP_API_URL || "";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

export interface AdminUserPayload {
  name: string;
  username?: string;
  email: string;
  password?: string;
  role: string;
  isActive?: boolean;
  appAccessEnabled?: boolean;
  phone?: string;
  employeeId?: string;
  designation?: string;
  department?: string;
  panNumber?: string;
  bankName?: string;
  accountNumber?: string;
  ifscCode?: string;
  uanNumber?: string;
  pfAccountNumber?: string;
  esiNumber?: string;
  aadharNumber?: string;
  dob?: string;
  emergencyContactNumber?: string;
  emergencyContactRelation?: string;
  permissions: Record<string, boolean>;
  assignedKitchenIds?: string[];
}

const adminUsersApi = {
  getUsers: async (): Promise<Admin[]> => {
    const response = await axios.get(`${API_URL}/api/admin/auth/list`, authHeaders());
    return response.data;
  },

  createUser: async (payload: AdminUserPayload) => {
    const response = await axios.post(
      `${API_URL}/api/admin/auth/create`,
      payload,
      authHeaders()
    );
    return response.data;
  },

  updateUser: async (id: string, payload: AdminUserPayload) => {
    const response = await axios.put(
      `${API_URL}/api/admin/auth/${id}`,
      payload,
      authHeaders()
    );
    return response.data;
  },

  deleteUser: async (id: string) => {
    const response = await axios.delete(
      `${API_URL}/api/admin/auth/${id}`,
      authHeaders()
    );
    return response.data;
  },
};

export default adminUsersApi;
